export const getParameterFallbackName = (parameterInput) => {
  if (typeof parameterInput === "string") {
    return parameterInput;
  }

  if (!parameterInput || typeof parameterInput !== "object") {
    return "";
  }

  return (
    parameterInput.parameter_name ||
    parameterInput.name ||
    parameterInput.title ||
    ""
  );
};

export const createTranslatedParameterNameResolver = (
  getLexiconId,
  translate
) => {
  return (parameterInput) => {
    const fallbackName = getParameterFallbackName(parameterInput);

    if (!fallbackName) {
      return "";
    }

    const lexiconId = getLexiconId?.(parameterInput);

    if (lexiconId) {
      return translate?.(lexiconId) || fallbackName;
    }

    return fallbackName;
  };
};
